// src/hooks/usePriests.js
import { useState, useEffect, useRef } from "react";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

function usePriests (){
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState("paper");
  const [priestData, setPriestData] = useState([]);
  const [selectedPriest, setSelectedPriest] = useState(null);
  const descriptionElementRef = useRef(null);

  const getPriests = async () => {
    const response = await getApi(apiEndPoints.getPriests);
    if (response && response.status === 200) {
      setPriestData(response.data);
    }
  };

  useEffect(() => {
    getPriests();
  }, []);

  const handleClickOpen = (priest) => () => {
    setSelectedPriest(priest);
    setOpen(true);
    setScroll("paper");
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return {
    open,
    scroll,
    priestData,
    selectedPriest,
    descriptionElementRef,
    handleClickOpen,
    handleClose,
  };
};

export default usePriests;
